module.exports = __webpack_public_path__ + "img/user-avatar.d492bfff.png";